import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes ,BrowserRouter,Navigate} from 'react-router-dom'
import './scss/style.scss'

// import DefaultLayout from "./layout/DefaultLayout";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers


// Pages
// const Login = React.lazy(() => import('./views/pages/login/Login'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
// const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const ProfileLayout = React.lazy(() => import('./layout/ProfileLayout'))
const PermissionLayout = React.lazy(() => import('./layout/PermissionLayout'))
const MarketingLayout = React.lazy(() => import('./layout/MarketingLayout'))



class App extends Component {

  render() {
    return (
      <HashRouter >
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/" name="Login Page" element={<Login />} />
            <Route exact path="/login" name="Login Page" element={<Login />} />
            {/*<Route exact path="/register" name="Register Page" element={<Register />} />  */}
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            {/*<Route path="/dashboard" name="Home" element={<DefaultLayout />} />*/}
            <Route path="/manage/profile/*" name="个人中心" element={<ProfileLayout />} />
            <Route path="/manage/permission" name="权限控制" element={<PermissionLayout />} />
            <Route path="/manage/marketing" name="市场部" element={<MarketingLayout />} />
            <Route path="/manage/*" name="Dashboard" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
